import React from "react";
import * as Styled from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import UserImage from "../UserImage";
import { TextView } from "@components";
import { useState } from "react";
import { ASSETS } from "../../utils/config";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircularProgress from "@mui/material/CircularProgress";
import { useGetWheelAuthors } from "../../services/queries";

export default function CloneAuthor({ style, wheelId }) {
  const [showAuthorInfo, setShowAuthorInfo] = useState(false);
  const [viewAll, setViewAll] = useState(false);

  const { data = {}, isLoading } = useGetWheelAuthors(wheelId);

  const original_author = data?.data?.extra?.original_auther;
  const cloned_from = data?.data?.extra?.cloned_from;
  const results = data?.data?.results || [];

  return (
    <div>
      {showAuthorInfo ? (
        <Styled.AuthorInfo style={style}>
          <Styled.AuthorHeader>
            <Styled.LeftView>
              <Styled.ImageView>
                <img src={ASSETS.author} style={{ width: 15, height: 15 }} />
              </Styled.ImageView>
              <TextView style={{ fontWeight: "500" }}>Credits</TextView>
            </Styled.LeftView>

            <CloseIcon
              onClick={() => setShowAuthorInfo(false)}
              style={{ cursor: "pointer" }}
            />
          </Styled.AuthorHeader>
          {isLoading ? (
            <Styled.Loader>
              <CircularProgress size={20} />
            </Styled.Loader>
          ) : (
            <>
              <Styled.AuthorView>
                <UserImage image={original_author?.profile_image} />
                <div style={{ marginLeft: 10 }}>
                  <TextView variant="subtitle">
                    {original_author?.first_name} {original_author?.last_name}
                  </TextView>
                  <TextView>Original Author</TextView>
                </div>
              </Styled.AuthorView>
              {!!results.length && (
                <Styled.OtherAuthors>
                  <Styled.Header>
                    <TextView>View other authors</TextView>
                    {viewAll ? (
                      <ExpandMoreIcon
                        onClick={() => setViewAll(false)}
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      <ChevronRightIcon
                        onClick={() => setViewAll(true)}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </Styled.Header>
                  {viewAll && (
                    <Styled.OtherAuthorView>
                      {results.map((user, index) => {
                        if (index !== 0) {
                          return (
                            <>
                              <Styled.Separator />
                              <Styled.OtherAuthorItem>
                                <UserImage
                                  size={24}
                                  image={user?.profile_image}
                                />
                                <TextView style={{ marginLeft: 6 }}>
                                  {user?.first_name} {user?.last_name}
                                </TextView>
                              </Styled.OtherAuthorItem>
                            </>
                          );
                        } else {
                          return (
                            <Styled.OtherAuthorItem>
                              <UserImage
                                size={24}
                                image={user?.profile_image}
                              />
                              <TextView style={{ marginLeft: 6 }}>
                                {user?.first_name} {user?.last_name}
                              </TextView>
                            </Styled.OtherAuthorItem>
                          );
                        }
                      })}
                    </Styled.OtherAuthorView>
                  )}
                </Styled.OtherAuthors>
              )}
              {cloned_from ? (
                <Styled.ClonedFrom>
                  <UserImage image={cloned_from?.profile_image} size={34} />
                  <div style={{ marginLeft: 10 }}>
                    <TextView>Cloned from</TextView>
                    <TextView variant="subtitle">
                      {cloned_from?.first_name} {cloned_from?.last_name}
                    </TextView>
                  </div>
                </Styled.ClonedFrom>
              ) : null}
            </>
          )}
        </Styled.AuthorInfo>
      ) : (
        <Styled.AuthorIcon onClick={() => setShowAuthorInfo(true)}>
          <img src={ASSETS.author} />
        </Styled.AuthorIcon>
      )}
    </div>
  );
}
